<template>
  <div class="pb50">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item :label="$t('店内营业时间')" prop="store_time"
        :rules="[{ required: true, message: $t('请选择店内营业时间'), trigger: 'change' }]">
        <el-time-picker is-range v-model="form.store_time" :range-separator="$t('至')" :start-placeholder="$t('开始时间')"
          :end-placeholder="$t('结束时间')" :placeholder="$t('选择时间范围')" format="HH:mm" value-format="HH:mm">
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('自提营业时间')" prop="pick_time"
        :rules="[{ required: true, message: $t('请选择自提营业时间'), trigger: 'change' }]">
        <el-time-picker is-range v-model="form.pick_time" :range-separator="$t('至')" :start-placeholder="$t('开始时间')"
          :end-placeholder="$t('结束时间')" :placeholder="$t('选择时间范围')" format="HH:mm" value-format="HH:mm">
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('外卖营业时间')" prop="delivery_time"
        :rules="[{ required: true, message: $t('请选择外卖营业时间'), trigger: 'change' }]">
        <el-time-picker is-range v-model="form.delivery_time" :range-separator="$t('至')" :start-placeholder="$t('开始时间')"
          :end-placeholder="$t('结束时间')" :placeholder="$t('选择时间范围')" format="HH:mm" value-format="HH:mm">
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('外卖配送')">
        <el-checkbox-group v-model="form.delivery_set">
          <el-checkbox v-for="(item,index) in deliver_type" :label="item.value" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
        <div class="tips">{{$t('注')}}：{{$t('外卖配送方式至少选择一个')}}</div>
      </el-form-item>
      <el-form-item :label="$t('店内配置')">
        <el-checkbox-group v-model="form.store_set">
          <el-checkbox v-for="(item,index) in store_type" :label="item.value" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
        <div class="tips">{{$t('注')}}：{{$t('店内用餐方式至少选择一个')}}</div>
      </el-form-item>
      <el-form-item :label="$t('店内堂食结算模式')">
        <el-radio-group v-model="form.settle_type">
          <el-radio :label="10">{{$t('先结账后用餐')}}</el-radio>
          <el-radio :label="20">{{$t('先用餐后结账')}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('收银台桌台清台设置')" v-if="form.settle_type==10">
        <el-radio-group v-model="form.auto_close">
          <el-radio :label="0">{{$t('定时清台')}}</el-radio>
          <el-radio :label="1">{{$t('立即清台')}}</el-radio>
        </el-radio-group>
        <div class="tips">{{$t('开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效')}}</div>
      </el-form-item>
      <el-form-item :rules="[{ required: true, message: ' ' }]" prop="close_time" label="桌台订单清台设置">
        <div class=" d-s-c">
          <div class="max-w60">
            <el-input v-model="form.close_time" type="number"></el-input>
          </div>
          <div class="ml10">{{$t('分钟后自动清理桌台')}}（{{$t('扫桌码点餐和收银桌台点餐定时清台时间')}}）</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('店内堂食服务费')">
        <el-radio-group v-model="form.serviceType">
          <el-radio :label="0">{{$t('按就餐人数收取')}}</el-radio>
          <el-radio :label="1">{{$t('按每桌台收取')}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.serviceType==0" label="" :rules="[{ required: true, message: $t('请输入服务费')}]"
        prop="bag_price">
        <div class=" d-s-c">
          <div class="max-w60">
            <el-input v-model="form.service_money" type="number"></el-input>
          </div>
          <div class="ml10">€/{{$t('位')}}</div>
        </div>
      </el-form-item>
      <el-form-item v-if="form.serviceType==1" label="" :rules="[{ required: true, message: $t('请输入服务费') }]"
        prop="bag_price">
        <div class=" d-s-c">
          <div class="max-w60">
            <el-input v-model="form.service_money" type="number"></el-input>
          </div>
          <div class="ml10">€/{{$t('桌')}}</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('外卖包装费类型')">
        <el-radio-group v-model="form.bag_type">
          <el-radio :label="0">{{$t('按菜品收费')}}</el-radio>
          <el-radio :label="1">{{$t('按单收费')}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.bag_type==1" :label="$t('包装费')" :rules="[{ required: true, message: $t('请输入包装费') }]"
        prop="bag_price">
        <div class=" d-s-c">
          <div class="max-w60">
            <el-input v-model="form.bag_price" type="number"></el-input>
          </div>
          <div class="ml10">€</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('店内包装费类型')">
        <el-radio-group v-model="form.storebag_type">
          <el-radio :label="0">{{$t('按菜品收费')}}</el-radio>
          <el-radio :label="1">{{$t('按单收费')}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.storebag_type==1" :label="$t('包装费')" :rules="[{ required: true, message: $t('请输入包装费') }]"
        prop="bag_price">
        <div class=" d-s-c">
          <div class="max-w60">
            <el-input v-model="form.storebag_price" type="number"></el-input>
          </div>
          <div class="ml10">€</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('外卖配送范围')" :rules="[{ required: true, message: $t('请输入外卖配送范围') }]" prop="delivery_distance">
        <div class=" d-s-c">
          <div class="max-w60">
            <el-input class="" v-model="form.delivery_distance" type="number"></el-input>
          </div>
          <div class="ml10">km</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('外卖配送费')" :rules="[{ required: true, message: $t('请输入外卖配送费') }]" prop="shipping_fee">
        <div class=" d-s-c">
          <div class="max-w60">
            <el-input v-model="form.shipping_fee" type="number"></el-input>
          </div>
          <div class="ml10">€</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('最低消费')" :rules="[{ required: true, message: $t('请输入最低消费') }]" prop="min_money">
        <div class=" d-s-c">
          <div class="max-w60">
            <el-input v-model="form.min_money" type="number"></el-input>
          </div>
          <div class="ml10">€</div>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" @click="cancelFunc">{{$t('取消')}}</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">{{$t('提交')}}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import SupplierApi from '@/api/supplier.js';
  import {
    formatModel
  } from '@/utils/base.js'
  export default {
    data() {
      return {
        /*表单对象*/
        form: {
          shop_supplier_id: 0,
          /*活动时间*/
          store_time: '',
          pick_time: '',
          delivery_time: '',
          bag_type: 0,
          bag_price: 0,
          storebag_type: 0,
          storebag_price: 0,
          delivery_distance: '',
          shipping_fee: 0,
          delivery_set: [],
          store_set: [],
          min_money: 0,
          settle_type: 10,
          serviceType: 0,
          service_money: 0,
          auto_close: 0,
          close_time: 0,
        },
        deliver_type: [{
          'name': this.$t('外卖配送'),
          'value': 10
        }, {
          'name': this.$t('到店自提'),
          'value': 20
        }],
        store_type: [{
          'name': this.$t('打包带走'),
          'value': 30
        }, {
          'name': this.$t('店内就餐'),
          'value': 40
        }],
        /*是否正在加载*/
        loading: false
      };
    },
    created() {
      this.form.shop_supplier_id = this.$route.query.shop_supplier_id;
      this.getData();
    },
    methods: {
      /*获取参数*/
      getData() {
        let self = this;
        SupplierApi.getsetSupplier({
            shop_supplier_id: self.form.shop_supplier_id
          }, true)
          .then(res => {
            self.form = formatModel(self.form, res.data.model);
            self.form.delivery_set = res.data.model.delivery_set;
            // 转成整数，兼容组件
            for (let i = 0; i < self.form.delivery_set.length; i++) {
              self.$set(self.form.delivery_set, i, parseInt(self.form.delivery_set[i]));
            }
            self.form.store_set = res.data.model.store_set;
            // 转成整数，兼容组件
            for (let i = 0; i < self.form.store_set.length; i++) {
              self.$set(self.form.store_set, i, parseInt(self.form.store_set[i]));
            }
            console.log(self.form)
          })
          .catch(error => {

          });
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        let params = self.form;
        if (params.delivery_set.length < 1) {
          self.$message({
            message: self.$t('外卖配送至少选择一种！'),
            type: 'warning'
          });
          return;
        }
        if (params.store_set.length < 1) {
          self.$message({
            message: self.$t('店内配置至少选择一种！'),
            type: 'warning'
          });
          return;
        }
        self.$refs.form.validate(valid => {
          if (valid) {

            console.log(params)
            self.loading = true;
            SupplierApi.setSupplier(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: self.$t('恭喜你，设置成功'),
                  type: 'success'
                });
                self.cancelFunc();
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      }
    }
  };
</script>

<style>
  .max-w60 {
    max-width: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/setting.vue